import styled from "styled-components";

interface IMoreBtnArrowImg {
  isShowed?: boolean
}

interface IMoreIntegrationsContainer {
  isShowed?: boolean
}

interface IIntegrationItem {
  order?: number | string
}

export const ImagesContainer = styled.div`
  margin: 51px 0 0;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (min-width: 980px) {
    margin: 53px 0 0;
    width: auto;
    overflow-x: auto;
  }
`

export const ImagesRow = styled.div`
  display: flex;
  align-items: center;
  margin: 0 -20px 42px -20px;
  flex-wrap: wrap;
  padding: 0 20px;
  justify-content: center;

  @media (min-width: 980px) {
    margin: 0 -20px 24px -20px;
    padding: 0;
  }
`

export const Logo = styled.div`
  margin: 0 20px;
  
  img {
    max-height: 22px;
    width: auto;
  }

  @media (min-width: 980px) {
    margin: 0;
    padding: 16px 0px;
    width: 210px;
    text-align: center;

    img {
      max-height: initial;
      width: auto;
    }
  }
`

export const MoreBtn = styled.button`
  font-weight: 500;
  font-size: 18px;
  line-height: 160%;
  color: #0D71D7;
  border: none;
  padding: 8px 12px;
  transition: 0.2s ease-in-out;
  border-radius: 8px;
  
  &:hover {
    background: #F7F7FA;
  }
`

export const MoreBtnArrow = styled.span``

export const MoreBtnArrowImg = styled.img<IMoreBtnArrowImg>`
  vertical-align: middle;
  transform: rotate(${({ isShowed }) => isShowed && '180deg' || '0'});
  transform-origin: center;
  transition: .2s ease-in-out;
`

export const MoreBtnContainer = styled.div`
  text-align: center;
`

export const MoreIntegrationsContainer = styled.div<IMoreIntegrationsContainer>`
  column-count: 2;
  width: 100%;
  margin: 24px auto 0;
  transition: 0.2s ease-in-out;
  transform-origin: top;

  @media (min-width: 980px) {
    width: 700px;
    column-gap: 124px;
    column-count: 3;
  }
  
  ${({ isShowed }) => isShowed && `
    opacity: 1;
    visibility: visible;
    transform: scaleY(100%);
    max-height: 1500px;
  ` || `
    opacity: 0;
    visibility: hidden;
    transform: scaleY(0);
    max-height: 0;
  `}
`

export const IntegrationItem = styled.div<IIntegrationItem>`
  flex: 0 0 50%;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;
  margin-bottom: 19px;
  padding-left: 10px;
  white-space: nowrap;
  order: ${({ order }) => order || 'initial'};

  @media (min-width: 980px) {
    flex: 0 0 148px;
    font-size: 18px;
    padding-left: 0;
    order: initial;
  }
`
